module.exports = __webpack_public_path__ + "static/media/Internal_Beneficiary.53a9931f.svg";